import LGSdk from '@/packages/plugins/languageSDK/index'

export const errorCodeLocales = (code) => {
  const errorCode = LGSdk.t(`errorCode.${code}`)
  if (errorCode && errorCode !== `errorCode.${code}`) {
    return errorCode
  } else {
    return // 或者返回一个默认的错误消息
  }
}
